import { Form } from '@ih/app/shared/apis/interfaces';

export class ShowDeleteConfirmationAction {
  public static readonly type =
    '[Project/Forms/List] ShowDeleteConfirmationAction';
  constructor(public readonly form: Form) {}
}
